// About.js
import React from 'react';
import rightImage from './assets/about_right.jpg'; // Adjust the path as necessary
import leftImage from './assets/about_left.jpg'; // Adjust the path as necessary


function About({ language, content }) {
  return (
    <section id="about" className="about-section">
      <div className="about-photo-container">
        {/* Replace with your actual image */}
        <img src={leftImage} alt="About page visual left" />
      </div>
      <div className="about-text-container">
        <p>{content.aboutText1}</p>
        <p>{content.aboutText2}</p>
      </div>
      <div className="about-photo-container">
        {/* Replace with your actual image */}
        <img src={rightImage} alt="About page visual right" />
      </div>
    </section>
  );
}

export default About;